import React, { useState } from 'react'
import Editor from 'react-simple-code-editor'
import { highlight, languages } from "prismjs/components/prism-core"

import { usePet } from '../../modules'

import Modal from '../reusable/modal'
import Receive from '../reusable/receive'
import Confirm from '../reusable/confirm'

import "prismjs/components/prism-clike"
import "prismjs/components/prism-javascript"
import "prismjs/themes/prism.css"

const TemplateEditor = ({ visible, toggle, id }) => {
    const [code, setCode] = useState('')

    const [{ loading, error }] = usePet('fetchPrintTemplate', { id }, { notify: true, callback: ({ data }) => setCode(data) })

    const onComplete = (_, notif, ops) => {
        notif('Template has been edited', ops('success'))
        setTimeout(toggle, 300)
    }

    const [{ loading: editLoading }, editTemplate] = usePet('writePrintTemplate', {
        id,
        content: code
    }, { notify: true, callback: onComplete, manual: true, load: { msg: 'Saving changes...' } })

    const close = () => {
        toggle()
    }

    const edit = () => Confirm({
        title: 'Edit Print Template',
        message: 'Please confirm before ediiting this template',
        onOk: editTemplate,
        okText: 'Edit Template'
    })

    return (
        <Modal
            w={ 800 }
            title="Edit Print Template"
            toggle={close}
            visible={visible}>
            <Receive
                loading={loading}
                error={ error }
                progress>
                {
                    code &&   
                    <Editor
                        value={code}
                        padding={10}
                        onValueChange={(str) => setCode(str)}
                        highlight={(str) => highlight(str, languages.js)}
                        style={{
                            fontFamily: "monospace",
                            fontSize: 15,
                            border: "1px solid black"
                        }} />
                }
            </Receive>
            <div className="flex justify-end mt-2">
                <button onClick={ close } className="text-white bg-gray-500 hover:bg-gray-600 mr-2 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center">Close</button>
                <button disabled={ editLoading } onClick={ edit } type="submit" className="text-white hisani-btn-orange-light font-medium rounded-lg text-sm px-5 py-2.5 text-center">Save</button>
            </div>
        </Modal>
    )
}

export default TemplateEditor